import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_PsychosocialTreatmentPlan = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_PsychosocialTreatmentPlan' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' name='chkMaster' id='chkMaster' className='add-only' value='1' />Master Psychosocial Treatment Plan
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' name='chkMaster1' id='chkMaster1' className='add-only' value='1' />Psychosocial Treatment Plan Review
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Diagnostic Descriptor:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Primary</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>ICD Diagnosis Code:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtDiagnosticDescriptor' name='txtDiagnosticDescriptor' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtPrimary' name='txtPrimary' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtDiagnosisCode' name='txtDiagnosisCode' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>GAF Score : &nbsp;</b>
                    <input type='text' id='txtScore' name='txtScore' className='add-only w-250 custom-add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Functional Areas Identified as Deficits in the Assessment</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkAreas' id='chkAreas' className='add-only' value='1' />Health/Medical
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkAreas1' id='chkAreas1' className='add-only' value='1' />Vocational/Educational
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkAreas2' id='chkAreas2' className='add-only' value='1' />Basic Living Skills
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkAreas3' id='chkAreas3' className='add-only' value='1' />Social/Interpersonal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkAreas4' id='chkAreas4' className='add-only' value='1' />Housing
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkAreas5' id='chkAreas5' className='add-only' value='1' />Community/Legal
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkAreas6' id='chkAreas6' className='add-only' value='1' />Family
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkAreas7' id='chkAreas7' className='add-only' value='1' />Financial
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkAreas8' id='chkAreas8' className='add-only' value='1' />Work/School
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Client Long-Term View:</span>
                    <textarea id='txtLongTermView' name='txtLongTermView' className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Input from Family and/or primary support </span>
                    <span className='small'>(if applicable):</span>
                    <textarea id='txtLongTermView1' name='txtLongTermView1' className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>1. CLIENT PROBLEM/NEEDS FROM ASSESSMENT:</span>
                    <textarea id='txtLongTermView2' name='txtLongTermView2' className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>1. CLIENT GOAL:</span>
                    <textarea id='txtLongTermView3' name='txtLongTermView3' className='add-only' ></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Client progress towards goal</span>
                            <span className='small'>(annual or changes Explain):</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkClientProgress' id='chkClientProgress' className='add-only' value='1' />No change
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkClientProgress1' id='chkClientProgress1' className='add-only' value='1' />Improving
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkClientProgress2' id='chkClientProgress2' className='add-only' value='1' />Regressing
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <b>CLIENT OBJECTIVES (Indicate measurable observable changes in target behavior)</b>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>1:1 Objective</span>
                    <textarea id='txtObjective' name='txtObjective' className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>1:2 Objective</span>
                    <textarea id='txtObjective1' name='txtObjective1' className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>1:3 Objective</span>
                    <textarea id='txtObjective2' name='txtObjective2' className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Treatment Providers:</span>
                    <textarea id='txtObjective3' name='txtObjective3' className='add-only' ></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-550'>
                            <span className='eleHeader'>TERMINATION CRITERIA</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Date Terminated:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-20'>1.1
                        </td>
                        <td className='w-530'>
                            <input type='text' id='txtTermination' name='txtTermination' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='date' id='txtDateTermination' name='txtDateTermination' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-20'>1.2
                        </td>
                        <td className='w-530'>
                            <input type='text' id='txtTermination1' name='txtTermination1' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='date' id='txtDateTermination1' name='txtDateTermination1' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-20'>1.3
                        </td>
                        <td className='w-530'>
                            <input type='text' id='txtTermination2' name='txtTermination2' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='date' id='txtDateTermination2' name='txtDateTermination2' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>2. CLIENT PROBLEM/NEEDS FROM ASSESSMENT:</span>
                    <textarea id='txtProblem' name='txtProblem' className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>2. CLIENT GOAL:</span>
                    <textarea id='txtProblem1' name='txtProblem1' className='add-only' ></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Client progress towards goal</span>
                            <span className='small'>(annual or changes Explain):</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkClientProgress3' id='chkClientProgress3' className='add-only' value='1' />No change
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkClientProgress4' id='chkClientProgress4' className='add-only' value='1' />Improving
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkClientProgress5' id='chkClientProgress5' className='add-only' value='1' />Regressing
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <b>CLIENT OBJECTIVES (Indicate measurable observable changes in target behavior)</b>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>2:1 Objective</span>
                    <textarea id='txtObjectiveIndicate' name='txtObjectiveIndicate' className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>2:2 Objective</span>
                    <textarea id='txtObjectiveIndicate1' name='txtObjectiveIndicate1' className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>2:3 Objective</span>
                    <textarea id='txtObjectiveIndicate2' name='txtObjectiveIndicate2' className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Treatment Providers:</span>
                    <textarea id='txtObjectiveIndicate311' name='txtObjectiveIndicate311' className='add-only' ></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-550'>
                            <span className='eleHeader'>TERMINATION CRITERIA</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Date Terminated:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-20'>2.1
                        </td>
                        <td className='w-530'>
                            <input type='text' id='txtTermination3' name='txtTermination3' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='date' id='txtDateTermination3' name='txtDateTermination3' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-20'>2.2
                        </td>
                        <td className='w-530'>
                            <input type='text' id='txtTermination4' name='txtTermination4' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='date' id='txtDateTermination4' name='txtDateTermination4' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-20'>2.3
                        </td>
                        <td className='w-530'>
                            <input type='text' id='txtTermination5' name='txtTermination5' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='date' id='txtDateTermination5' name='txtDateTermination5' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>3. CLIENT PROBLEM/NEEDS FROM ASSESSMENT:</span>
                    <textarea id='txtProblem4' name='txtProblem4' className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>3. CLIENT GOAL:</span>
                    <textarea id='txtProblem5' name='txtProblem5' className='add-only' ></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Client progress towards goal</span>
                            <span className='small'>(annual or changes Explain):</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkClientProgress13' id='chkClientProgress13' className='add-only' value='1' />No change
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkClientProgress14' id='chkClientProgress14' className='add-only' value='1' />Improving
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkClientProgress15' id='chkClientProgress15' className='add-only' value='1' />Regressing
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <b>CLIENT OBJECTIVES (Indicate measurable observable changes in target behavior)</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>3:1 Objective</span>
                    <textarea id='txtObjectiveIndicate3' name='txtObjectiveIndicate3' className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>3:2 Objective</span>
                    <textarea id='txtObjectiveIndicate31' name='txtObjectiveIndicate31' className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>3:3 Objective</span>
                    <textarea id='txtObjectiveIndicate32' name='txtObjectiveIndicate32' className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Treatment Providers:</span>
                    <textarea id='txtObjectiveIndicate33' name='txtObjectiveIndicate33' className='add-only' ></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-550'>
                            <span className='eleHeader'>TERMINATION CRITERIA</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Date Terminated:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>3.1
                        </td>
                        <td className='w-530'>
                            <input type='text' id='txtTermination13' name='txtTermination13' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='date' id='txtDateTermination13' name='txtDateTermination13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>3.2
                        </td>
                        <td className='w-530'>
                            <input type='text' id='txtTermination14' name='txtTermination14' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='date' id='txtDateTermination14' name='txtDateTermination14' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>3.3
                        </td>
                        <td className='w-530'>
                            <input type='text' id='txtTermination15' name='txtTermination15' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='date' id='txtDateTermination15' name='txtDateTermination15' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>4. CLIENT PROBLEM/NEEDS FROM ASSESSMENT:</span>
                    <textarea id='txtProblem24' name='txtProblem24' className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>4. CLIENT GOAL:</span>
                    <textarea id='txtProblem25' name='txtProblem25' className='add-only' ></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Client progress towards goal</span>
                            <span className='small'>(annual or changes Explain):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkClientProgress113' id='chkClientProgress113' className='add-only' value='1' />No change
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkClientProgress114' id='chkClientProgress114' className='add-only' value='1' />Improving
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkClientProgress115' id='chkClientProgress115' className='add-only' value='1' />Regressing
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>CLIENT OBJECTIVES (Indicate measurable observable changes in target behavior)</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>4:1 Objective</span>
                    <textarea id='txtObjectiveIndicate13' name='txtObjectiveIndicate13' className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>4:2 Objective</span>
                    <textarea id='txtObjectiveIndicate131' name='txtObjectiveIndicate131' className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>4:3 Objective</span>
                    <textarea id='txtObjectiveIndicate132' name='txtObjectiveIndicate132' className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Treatment Providers:</span>
                    <textarea id='txtObjectiveIndicate133' name='txtObjectiveIndicate133' className='add-only' ></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-550'>
                            <span className='eleHeader'>TERMINATION CRITERIA</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Date Terminated:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-20'>4.1
                        </td>
                        <td className='w-530'>
                            <input type='text' id='txtTermination113' name='txtTermination113' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='date' id='txtDateTermination113' name='txtDateTermination113' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-20'>4.2
                        </td>
                        <td className='w-530'>
                            <input type='text' id='txtTermination114' name='txtTermination114' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='date' id='txtDateTermination114' name='txtDateTermination114' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-20'>4.3
                        </td>
                        <td className='w-530'>
                            <input type='text' id='txtTermination115' name='txtTermination115' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='date' id='txtDateTermination115' name='txtDateTermination115' className='add-only' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>SERVICE TYPES</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>FREQUENCY</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>LENGTH OF SESSION</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>DURATION OF TREATMENT</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkServiceType' id='chkServiceType' className='add-only' value='1' />ASSESSMENT/REVIEW
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency' name='txtFrequency' className='add-only w-80 custom-add-only' /> X ANNUALLY
                        </td>

                        <td className='w-200'>
                            <input type='text' id='txtLength' name='txtLength' className='add-only w-80 custom-add-only' />&nbsp; HOURS &nbsp;
                            <input type='text' id='txtLengthSession' name='txtLengthSession' className='add-only w-80 custom-add-only' />&nbsp; MINUTES &nbsp;
                        </td>

                        <td className='w-150'><input type='text' id='txtDuration' name='txtDuration' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-200'><input type='checkbox' name='chkServiceType2' id='chkServiceType2' className='add-only' value='1' />INDIVIDUAL THERAPY</td>

                        <td className='w-200'>
                            <input type='text' id='txtFrequency2' name='txtFrequency2' className='add-only w-80 custom-add-only' /> &nbsp; X &nbsp;
                            <input type='text' id='txtFrequencySess2' name='txtFrequencySess2' className='add-only w-80 custom-add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtLength2' name='txtLength2' className='add-only w-80 custom-add-only' />&nbsp; HOURS &nbsp;
                            <input type='text' id='txtLengthSession2' name='txtLengthSession2' className='add-only w-80 custom-add-only' />&nbsp; MINUTES &nbsp;
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration2' name='txtDuration2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkServiceType3' id='chkServiceType3' className='add-only' value='1' />GROUP THERAPY
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency3' name='txtFrequency3' className='add-only w-80 custom-add-only' />&nbsp; X &nbsp;
                            <input type='text' id='txtFrequencySess3' name='txtFrequencySess3' className='add-only w-80 custom-add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtLength3' name='txtLength3' className='add-only w-80 custom-add-only' />&nbsp; HOURS &nbsp;
                            <input type='text' id='txtLengthSession3' name='txtLengthSession3' className='add-only w-80 custom-add-only' />&nbsp; MINUTES &nbsp;
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration3' name='txtDuration3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkServiceType4' id='chkServiceType4' className='add-only' value='1' />ITOS
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency4' name='txtFrequency4' className='add-only w-80 custom-add-only' />&nbsp; X &nbsp;
                            <input type='text' id='txtFrequencySess4' name='txtFrequencySess4' className='add-only w-80 custom-add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtLength4' name='txtLength4' className='add-only w-80 custom-add-only' />&nbsp; HOURS &nbsp;
                            <input type='text' id='txtLengthSession4' name='txtLengthSession4' className='add-only w-80 custom-add-only' />&nbsp; MINUTES &nbsp;
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration4' name='txtDuration4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkServiceType5' id='chkServiceType5' className='add-only' value='1' />MEDICATION MANAGEMENT
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency5' name='txtFrequency5' className='add-only w-80 custom-add-only' />&nbsp; X &nbsp;
                            <input type='text' id='txtFrequencySess5' name='txtFrequencySess5' className='add-only w-80 custom-add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtLength5' name='txtLength5' className='add-only w-80 custom-add-only' />&nbsp; HOURS &nbsp;
                            <input type='text' id='txtLengthSession5' name='txtLengthSession5' className='add-only w-80 custom-add-only' />&nbsp; MINUTES &nbsp;
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration5' name='txtDuration5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkServiceType6' id='chkServiceType6' className='add-only' value='1' />PSYCHIATRICEVALUATION / UPDATE
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency6' name='txtFrequency6' className='add-only w-80 custom-add-only' />&nbsp;X ANNUALLY
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtLength6' name='txtLength6' className='add-only w-80 custom-add-only' />&nbsp; HOURS &nbsp;
                            <input type='text' id='txtLengthSession6' name='txtLengthSession6' className='add-only w-80 custom-add-only' />&nbsp; MINUTES &nbsp;
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration6' name='txtDuration6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkServiceType7' id='chkServiceType7' className='add-only' value='1' />COLLATERAL WITH
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency7' name='txtFrequency7' className='add-only w-80 custom-add-only' />&nbsp; X &nbsp;
                            <input type='text' id='txtFrequencySess7' name='txtFrequencySess7' className='add-only w-80 custom-add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtLength7' name='txtLength7' className='add-only w-80 custom-add-only' />&nbsp; HOURS &nbsp;
                            <input type='text' id='txtLengthSession7' name='txtLengthSession7' className='add-only w-80 custom-add-only' />&nbsp; MINUTES &nbsp;
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration7' name='txtDuration7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkServiceType8' id='chkServiceType8' className='add-only' value='1' />CASE MANAGEMENT/ MONITORING
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency8' name='txtFrequency8' className='add-only w-80 custom-add-only' />&nbsp; X &nbsp;
                            <input type='text' id='txtFrequencySess8' name='txtFrequencySess8' className='add-only w-80 custom-add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtLength8' name='txtLength8' className='add-only w-80 custom-add-only' />&nbsp; HOURS &nbsp;
                            <input type='text' id='txtLengthSession8' name='txtLengthSession8' className='add-only w-80 custom-add-only' />&nbsp; MINUTES &nbsp;
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration8' name='txtDuration8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkServiceType9' id='chkServiceType9' className='add-only' value='1' />ADL SKILLS, PSYCHOSOCIAL
                            REHAB AND COUNSELING
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency9' name='txtFrequency9' className='add-only w-80 custom-add-only' />&nbsp; X &nbsp;
                            <input type='text' id='txtFrequencySess9' name='txtFrequencySess9' className='add-only w-80 custom-add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtLength9' name='txtLength9' className='add-only w-80 custom-add-only' />&nbsp; HOURS &nbsp;
                            <input type='text' id='txtLengthSession9' name='txtLengthSession9' className='add-only w-80 custom-add-only' />&nbsp; MINUTES &nbsp;
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration9' name='txtDuration9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkServiceType10' id='chkServiceType10' className='add-only' value='1' />DAY TREATMENT SERVICES
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency10' name='txtFrequency10' className='add-only w-80 custom-add-only' />&nbsp; X &nbsp;
                            <input type='text' id='txtFrequencySess10' name='txtFrequencySess10' className='add-only w-80 custom-add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtLength10' name='txtLength10' className='add-only w-80 custom-add-only' />&nbsp; HOURS &nbsp;
                            <input type='text' id='txtLengthSession10' name='txtLengthSession10' className='add-only w-80 custom-add-only' />&nbsp; MINUTES &nbsp;
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration10' name='txtDuration10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkServiceType11' id='chkServiceType11' className='add-only' value='1' />FAMILY THERAPY
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency11' name='txtFrequency11' className='add-only w-80 custom-add-only' />&nbsp; X &nbsp;
                            <input type='text' id='txtFrequencySess11' name='txtFrequencySess11' className='add-only w-80 custom-add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtLength11' name='txtLength11' className='add-only w-80 custom-add-only' />&nbsp; HOURS &nbsp;
                            <input type='text' id='txtLengthSession11' name='txtLengthSession11' className='add-only w-80 custom-add-only' />&nbsp; MINUTES &nbsp;
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration11' name='txtDuration11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkServiceType12' id='txtFrequency12' className='add-only' value='1' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency125' name='txtFrequency125' className='add-only w-80 custom-add-only' />&nbsp; X &nbsp;
                            <input type='text' id='txtFrequencySess12' name='txtFrequencySess12' className='add-only w-80 custom-add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtLength12' name='txtLength12' className='add-only w-80 custom-add-only' />&nbsp; HOURS &nbsp;
                            <input type='text' id='txtLengthSession12' name='txtLengthSession12' className='add-only w-80 custom-add-only' />&nbsp; MINUTES &nbsp;
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration12' name='txtDuration12' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Referral Agencies:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Agency:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone Number:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtReferralAgencies' name='txtReferralAgencies' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAgency' name='txtAgency' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtPhoneNumber' name='txtPhoneNumber' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Agency:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone Number:</span>
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtAgency1' name='txtAgency1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtPhoneNumber1' name='txtPhoneNumber1' className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>I/We/have participated in the development of this plan.</span>
                    <input type='radio' id='rbRelationship_Yes' name='rbRelationship' className='add-only' value='1' /> Yes
                    <input type='radio' id='rbRelationship_No' name='rbRelationship' className='add-only' value='2' /> No &nbsp;
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Client received a copy of his/her plan:</span>
                    <input type='radio' id='rbRelationship1_Yes' name='rbRelationship1' className='add-only' value='1' /> Yes
                    <input type='radio' id='rbRelationship1_No' name='rbRelationship1' className='add-only' value='2' /> No &nbsp;
                </p>

                <p className='w-750'>
                    Treatment Plan Review Date:<input type='text' id='txtPhoneNumber5' name='txtPhoneNumber5' className='add-only' />
                </p>

                <p className='w-750'>This is to certify that the Services prescribed and recommended in this treatment plan are
                    appropriate and medically necessary to meet the recipient's need, as defined by the Florida Medicaid Program.</p>



            </div>
        </form>
    )
}

